import React from "react";

const UserStats = ({ stats }) => {
  return (
    <div className="bg-white border-light rounded-16 px-30 py-30 shadow-4">
      <div className="d-flex items-center mb-20">
        <div className="size-40 d-flex justify-center items-center bg-blue-3 rounded-full mr-15">
          <i className="text-16 icon-users text-blue-1"></i>
        </div>
        <h5 className="text-18 lh-1 fw-500">Manage Users</h5>
      </div>
      
      <div className="y-gap-15 mb-25">
        <div className="d-flex items-center justify-between py-10">
          <div className="text-15 fw-500">Total Users</div>
          <div className="text-15 fw-500 text-purple-1">{stats.totalUsers}</div>
        </div>
        <div className="d-flex items-center justify-between py-10">
          <div className="text-15">Active Students</div>
          <div className="text-15">{stats.activeStudents}</div>
        </div>
        <div className="d-flex items-center justify-between py-10">
          <div className="text-15">Active Instructors</div>
          <div className="text-15">{stats.activeInstructors}</div>
        </div>
        <div className="d-flex items-center justify-between py-10 border-bottom-light pb-15">
          <div className="text-15">Pending Activation</div>
          <div className="text-15 text-orange-1">{stats.suspendedUsers}</div>
        </div>
      </div>
      
      <div className="row y-gap-15">
        <div className="col-12">
          <button className="button -sm bg-blue-1 text-white fw-500 w-1/1">
            <i className="icon-search mr-10"></i>
            Search Users
          </button>
        </div>
        <div className="col-6">
          <button className="button -sm bg-orange-3 text-orange-1 fw-500 w-1/1">
            <i className="icon-pause mr-10"></i>
            Suspend User
          </button>
        </div>
        <div className="col-6">
          <button className="button -sm bg-red-3 text-red-1 fw-500 w-1/1">
            <i className="icon-trash mr-10"></i>
            Delete User
          </button>
        </div>
      </div>
    </div>
  );
};

export default UserStats; 